import React, { useState } from "react";

import Form from "react-bootstrap/Form";

import S3 from "react-aws-s3";
import Resizer from "react-image-file-resizer";




const BlogImageUploader = (props) => {
    console.log(props)
    const resizeFile = (file, filetype) =>
        new Promise((resolve) => {
            Resizer.imageFileResizer(
            file,
            props.width,
            props.height,
            filetype,
            100,
            0,
            (uri) => {
                resolve(uri);
            },
            "file"
        );
    });

    const [fileUploadSuccess, setFileUploadSuccess] = useState();

    const uploadFile = async (file) => {
        const filetype = props.filetype ? props.filetype : file.type.substring(file.type.lastIndexOf('/') + 1)
        console.log(filetype)
        try {
            let image;
            if(props.width){
                image = await resizeFile(file, filetype);
            }else{
                image = file
            }
            console.log(image)
            const fd = new FormData();
            fd.append('file', image);
            fd.append('filename', `${props.filename ? `${props.filename}.${filetype.toLowerCase() === "png" ? "png" : ""}${filetype.toLowerCase() === "jpeg" || filetype.toLowerCase() === "jpg"  ? "jpeg" : ""}` : image.name }`)
            fd.append('dirname', props.dirname)
            fd.append('filetype', image.type)

            fetch(`${process.env.REACT_APP_SERVER_ADDRESS}/${"intranetfileupload/upload"}?key=${process.env.REACT_APP_SERVER_API_KEY}`, {
                method: 'POST',
                body: fd
            })
            .then(res => res.json())
            .then(data => {
                console.log(data); 
                props.setImageLocation(data.location); 
                setFileUploadSuccess(true)
            })
            .catch(err => console.error(err));
            

          } catch (err) {
            console.log(err);
          }

        
    }

    return (
        <>
            <div style={{fontWeight: "700", paddingBottom:"10px"}}>{props.title || "Upload File"}</div>
                    {fileUploadSuccess ?
                        "File Uploaded Successfully"
                        :
                        <Form.Group>
                            <Form.File onChange={e => uploadFile(e.target.files[0])} />
                        </Form.Group>
                }
        </>
    )



}

export default BlogImageUploader;